import type { KeyboardLayoutId } from '../types';

/** Characters produced via Alt/Option on Danish layouts (not Shift). */
export function charFromAltKeyEvent(
  e: KeyboardEvent,
  _layoutId: KeyboardLayoutId,
): string | null {
  if (!e.altKey || e.metaKey || e.ctrlKey) return null;
  const key = e.key;
  if (key.length !== 1) return null;

  // Mac: Option+2 → @. PC: Alt Gr+2 → @ (often reported as altKey).
  if (key === '2' || key === '@') {
    return '@';
  }
  return null;
}

export function altLayerHint(layoutId: KeyboardLayoutId): string {
  if (layoutId === 'mac-dk') {
    return 'På Mac: hold Option (⌥) og tryk 2 for @.';
  }
  return 'På PC: hold Alt Gr og tryk 2 for @.';
}
